// src/shared/components/ui/select.tsx

import { ChevronDown } from 'lucide-react'
import type { SelectHTMLAttributes } from 'react'

import { cn } from '@/shared/utils/cn'

type SelectSize = 'sm' | 'md' | 'lg'

const selectSizeMap: Record<SelectSize, string> = {
  sm: 'h-8 text-xs',
  md: 'h-9 text-sm',
  lg: 'h-10 text-sm',
}

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  selectSize?: SelectSize
  invalid?: boolean
}

export function Select({ className, selectSize = 'md', invalid, children, ...props }: SelectProps) {
  return (
    <span className="relative inline-flex w-full">
      <select
        aria-invalid={invalid || undefined}
        className={cn(
          'w-full appearance-none rounded-md border bg-[var(--panel)] pl-3 pr-10 text-[var(--color-text)] transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--panel)] disabled:cursor-not-allowed disabled:opacity-50',
          selectSizeMap[selectSize],
          invalid
            ? 'border-[var(--color-danger)] focus-visible:ring-[var(--color-danger)]'
            : 'border-[var(--panel-border)] focus-visible:ring-[var(--color-brand)] focus-visible:border-[var(--color-brand)]',
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--color-text-muted)]" />
    </span>
  )
}
